import _ from "lodash";

const mapData = (data, getDisplayName) => {
  const mappedData = data.map((i) => ({
    ...i,
    displayName: getDisplayName ? getDisplayName(i): i.name,
  }));

  return {
    map: _.keyBy(mappedData, "id"),
    list: mappedData,
  };
};

export default {
  setOrganizations: (state, data) => {
    const preparedData =  mapData(data);
    state.organizations = preparedData.list
    state.organizationsMap = preparedData.map;
  },
  setBusinessGroups: (state, data) => {
    const preparedData =  mapData(data);
    state.businessGroups = preparedData.list
    state.businessGroupsMap = preparedData.map;
  },
  setBillingInfos: (state, data) => {
    const preparedData =  mapData(data);
    state.billingInfos = preparedData.list
    state.billingInfosMap = preparedData.map;
  },
  setPricingLevelGroups: (state, data) => {
    const preparedData =  mapData(data,(i)=>i.description);
    state.pricingLevelGroups = preparedData.list
    state.pricingLevelGroupsMap = preparedData.map;
  },
};
